<template>
<table cellpadding="0" cellspacing="0" :class="disable?'table-time-disable':'table-time'">
    <tr class="time-tr">
        <td width="60" class="time-first-td">
            <input type="text" ref="hourInput" @blur="hourBlur($event)" @afterpaste="hourValue=hourValue.replace(/[^0-9]/g,'');" :class="[disable?numberDisableClass:'time-input']" v-model="hourValue" @click.stop="hourValueClick($event)" maxlength="2" @change="checkHourNum()" class="time-input time-value-width" name="HH" v-bind:disabled='disable' />
            <input type="text" class="time-input time-icon-width" readonly="true" value=":" :class="[disable?'time-input-disabled':'time-input']" />
            <input type="text" ref="minteInput" @blur="minuteBlur($event)" @afterpaste="minuteValue=minuteValue.replace(/[^0-9]/g,'');" :class="[disable?numberDisableClass:'time-input']" v-model="minuteValue" @click.stop.stop="minuteValueClick($event)" @change="checkMinuteNum()" maxlength="2" class="time-input time-value-width" name="MM" value="45" v-bind:disabled='disable' />
        </td>
        <td width="30" class="time-second-td">
            <input type="button" hidefocus="true" class="time-buton icon-util" @click.stop.stop="add()" @mousedown.stop="startTimer('add')" @mouseup="endTimer()" @mouseleave="endTimer()" v-bind:disabled='disable' :class="disable?disableUpClass:'time-drop-down-up'" />
            <input type="button" hidefocus="true" class="time-buton icon-util" @click.stop.stop="subtract()" @mousedown.stop="startTimer()" @mouseup="endTimer()" @mouseleave="endTimer()" v-bind:disabled='disable' :class="disable?disableDownClass:'time-drop-down'" />
        </td>
    </tr>
</table>
</template>

<script>
import "@/assets/css/time_selector.css";
export default {
    props: ['disable'],
    data: function () {
        return {
            checkHour: false,
            checkMinute: false,
            hourValue: null,
            minuteValue: '02',
            mouseDownSign: false,
            timer: null,
            intervalTimer: null,
            num: 0,
            disableDownClass: 'down-narrow',
            disableUpClass: 'up-narrow',
            numberDisableClass: 'time-input-disabled',
            timeValue: ''
        }
    },
    created() {
        this.hourValue = new Date().getHours();
        this.minuteValue = new Date().getMinutes();
        this.minuteValue = this.minuteValue < 10 ? ('0' + this.minuteValue) : this.minuteValue;
        this.timeValue = this.hourValue + ':' + this.minuteValue;
        this.$emit('changeTime', this.timeValue);
    },
    watch: {
        timeValue(newValue, oldValue) {
            this.$emit('changeTime', newValue);
        }
    },
    methods: {
        timeClick() {
            window.getSelection().empty();
        },
        minuteBlur(event) {
            this.checkMinuteNum();
            if (this.checkMinute) {
                if (this.minuteValue.replace) {
                    this.minuteValue = this.minuteValue.replace(/[^0-9]/g, '');
                }
                event.currentTarget.select();
            }
        },
        hourBlur(event) {
            this.checkHourNum();
            if (this.checkHour) {
                if (this.hourValue.replace) {
                    this.hourValue = this.hourValue.replace(/[^0-9]/g, '');
                }
                event.currentTarget.select();
            }
        },
        hourValueClick(event) {
            let that = this;
            if (!that.checkHour && !that.checkMinute) {
                that.$parent.$parent.$parent.$parent.reSet();
            }
            setTimeout(function () {
                that.checkHour = true;
                that.checkMinute = false;
                that.$refs.hourInput.select();
            }, 100);
        },
        minuteValueClick(event) {
            let that = this;
            if (!that.checkHour && !that.checkMinute) {
                that.$parent.$parent.$parent.$parent.reSet();
            }
            setTimeout(function () {
                that.checkMinute = true;
                that.checkHour = false;
                that.$refs.minteInput.select();
            }, 100);
        },
        checkHourNum() {
            if (parseInt(this.hourValue) >= 24) {
                this.hourValue = '00';
            } else if (this.hourValue == '0-1') {
                this.hourValue = '23';
            } else if (parseInt(this.hourValue) < 10) {
                this.hourValue = '0' + parseInt(this.hourValue);
            }
            this.timeValue = this.hourValue + ':' + this.minuteValue;
        },
        checkMinuteNum() {
            if (parseInt(this.minuteValue) >= 60) {
                this.minuteValue = '00';
                this.hourValue = parseInt(this.hourValue) + 1;
            } else if (this.minuteValue == '0-1') {
                this.minuteValue = '59';
                this.hourValue = parseInt(this.hourValue) - 1;
            } else if (parseInt(this.minuteValue) < 10) {
                this.minuteValue = '0' + parseInt(this.minuteValue);
            }
            this.checkHourNum();
            this.timeValue = this.hourValue + ':' + this.minuteValue;

        },
        add() {
            let that = this;
            setTimeout(function () {
                if (that.checkHour) {
                    that.addHourValue();
                    that.$nextTick(function () {
                        that.$refs.hourInput.select();
                    });
                } else if (that.checkMinute) {
                    that.addMinuteValue();
                    that.$nextTick(function () {
                        that.$refs.minteInput.select();
                    });
                } else if (!that.checkHour && !that.checkMinute) {
                    that.$parent.$parent.$parent.$parent.reSet();
                    that.checkMinute = true;
                    that.$nextTick(function () {
                        that.$refs.minteInput.select();

                    });
                    that.addMinuteValue();
                }
            }, 100);
        },
        addHourValue() {
            if (this.hourValue < 9) {
                this.num = parseInt(this.hourValue.slice(1));
                this.num = this.num + 1;
                this.hourValue = "0" + this.num;
            } else {
                this.hourValue++;
            }
            this.checkHourNum();
        },
        addMinuteValue() {
            if (this.minuteValue < 9) {
                this.num = parseInt(this.minuteValue.slice(1));
                this.num = this.num + 1;
                this.minuteValue = "0" + this.num;
            } else {
                this.minuteValue++;
            }
            this.checkMinuteNum();
        },
        subtract() {
            let that = this;
            setTimeout(function () {
                if (that.checkHour) {
                    that.subtractHourValue();
                    that.$nextTick(function () {
                        that.$refs.hourInput.select();
                    });
                } else if (that.checkMinute) {
                    that.subtractMinuteValue();
                    that.$nextTick(function () {
                        that.$refs.minteInput.select();
                    });
                } else if (!that.checkHour && !that.checkMinute) {
                    that.$parent.$parent.$parent.$parent.reSet();
                    that.subtractMinuteValue();
                    that.checkMinute = true;
                    that.$nextTick(function () {
                        that.$refs.minteInput.select();
                    });
                }
            }, 100);
        },
        subtractHourValue() {
            if (this.hourValue <= 10) {
                if (this.hourValue == 10) {
                    this.num = this.hourValue;
                    this.num--;
                } else {
                    this.hourValue = "0" + this.hourValue;
                    this.num = parseInt(this.hourValue.slice(1));
                    this.num = this.num - 1;
                }
                this.hourValue = "0" + this.num;
            } else {
                this.hourValue--;
            }
            this.checkHourNum();
        },
        subtractMinuteValue() {
            if (this.minuteValue <= 10) {
                if (this.minuteValue == 10) {
                    this.num = this.minuteValue;
                    this.num--;
                } else {
                    this.minuteValue = "0" + this.minuteValue;
                    this.num = parseInt(this.minuteValue.slice(1));
                    this.num = this.num - 1;
                }
                this.minuteValue = "0" + this.num;
            } else {
                this.minuteValue--;
            }
            this.checkMinuteNum();
        },
        startTimer(flag) {
            this.timer = setTimeout(() => {
                this.intervalTimer = setInterval(() => {
                    if (flag == 'add') {
                        this.add();
                    } else {
                        this.subtract();
                    }
                }, 200);
            }, 1000);
        },
        endTimer() {
            clearTimeout(this.timer);
            this.timer = null;
            clearTimeout(this.intervalTimer);
            this.intervalTimer = null;
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/selector/time_selector.vue